// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/components/CommonWorkBenchDrawer.jsx
// =============================================================================

import React, {
  useState
} from "react";

import {
  X,
  Maximize2,
  Minimize2
} from "lucide-react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function CommonWorkBenchDrawer({

  open,

  title,

  children,

  footer,

  onClose

}) {

  // ===========================================================================
  // STATE
  // ===========================================================================
  const [maximized, setMaximized] =
    useState(false);


  // ===========================================================================
  // CLOSE
  // ===========================================================================
  if (!open) {

    return null;
  }


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <>


      {/* ================================================================ */}
      {/* BACKDROP */}
      {/* ================================================================ */}
      <div
        style={styles.backdrop}
        onClick={onClose}
      />


      {/* ================================================================ */}
      {/* DRAWER */}
      {/* ================================================================ */}
      <div

        style={{

          ...styles.drawer,

          width:
            maximized
              ? "100%"
              : "52%"
        }}
      >


        {/* ============================================================ */}
        {/* HEADER */}
        {/* ============================================================ */}
        <div style={styles.header}>


          <div style={styles.title}>

            {title}

          </div>


          <div style={styles.headerActions}>


            {/* -------------------------------------------------------- */}
            {/* MAXIMIZE / RESTORE */}
            {/* -------------------------------------------------------- */}
            <button

              style={styles.iconBtn}

              onClick={() =>

                setMaximized(
                  !maximized
                )
              }
            >

              {

                maximized

                  ? <Minimize2 size={18} />

                  : <Maximize2 size={18} />
              }

            </button>


            {/* -------------------------------------------------------- */}
            {/* CLOSE */}
            {/* -------------------------------------------------------- */}
            <button

              style={styles.iconBtn}

              onClick={onClose}
            >

              <X size={18} />

            </button>

          </div>

        </div>


        {/* ============================================================ */}
        {/* BODY */}
        {/* ============================================================ */}
        <div style={styles.body}>


          {children}

        </div>


        {/* ============================================================ */}
        {/* FOOTER */}
        {/* ============================================================ */}
        {

          footer && (

            <div style={styles.footer}>


              {footer}

            </div>
          )
        }

      </div>

    </>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  backdrop: {

    position: "fixed",

    top: 0,

    left: 0,

    right: 0,

    bottom: 0,

    background:
      "rgba(0,0,0,0.45)",

    zIndex: 9998
  },

  drawer: {

    position: "fixed",

    top: 0,

    right: 0,

    bottom: 0,

    background: "#f5f7fb",

    zIndex: 9999,

    display: "flex",

    flexDirection: "column",

    boxShadow:
      "-4px 0 12px rgba(0,0,0,0.12)",

    transition:
      "width 0.25s ease"
  },

  header: {

    height: 64,

    minHeight: 64,

    background: "#ffffff",

    borderBottom:
      "1px solid #e5e7eb",

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    padding: "0 20px",

    position: "sticky",

    top: 0,

    zIndex: 2
  },

  title: {

    fontSize: 18,

    fontWeight: 700,

    color: "#111827"
  },

  headerActions: {

    display: "flex",

    alignItems: "center",

    gap: 8
  },

  iconBtn: {

    width: 36,

    height: 36,

    borderRadius: 8,

    border:
      "1px solid #d1d5db",

    background: "#ffffff",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    cursor: "pointer"
  },

  body: {

    flex: 1,

    overflowY: "auto",

    padding: 20
  },

  footer: {

    minHeight: 70,

    background: "#ffffff",

    borderTop:
      "1px solid #e5e7eb",

    display: "flex",

    alignItems: "center",

    justifyContent: "flex-end",

    gap: 12,

    padding: "0 20px",

    position: "sticky",

    bottom: 0
  }
};